import { Notification } from "@/components/admin/notification";
import { useTranslate } from "ra-core";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const ConfirmationRequired = () => {
  const translate = useTranslate();
  const { darkModeLogo: logo, title } = useConfigurationContext();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-3xl border bg-card p-8 shadow-card">
        <div className="mb-8 flex items-center gap-4">
          <img
            src={logo}
            alt={title}
            width={24}
            className="filter brightness-0 dark:invert"
          />
          <h1 className="text-xl font-semibold">{title}</h1>
        </div>
        <div className="h-full text-center">
          <div className="max-w-sm mx-auto h-full flex flex-col justify-center gap-4">
            <h1 className="text-2xl font-bold mb-4">
              {translate("crm.auth.welcome_title", {
                _: "Welcome to Avante",
              })}
            </h1>
            <p className="text-base mb-4">
              {translate("crm.auth.confirmation_required", {
                _: "Please follow the link we just sent you by email to confirm your account.",
              })}
            </p>
          </div>
        </div>
        <Notification />
      </div>
    </div>
  );
};

ConfirmationRequired.path = "/sign-up/confirm";
